//react
import { useEffect, useState, useRef, useReducer } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// responsive
import { M, T } from "../../../utils/MT";

// img
import SwiperBtn from "../../../assets/img/icon/icon_swiper_btn.svg";
import OptionSvg from "../../../assets/img/icon/icon_option.svg";
import BagSvg from "../../../assets/img/icon/icon_bag.svg";
import DeliverySvg from "../../../assets/img/icon/icon_delivery.svg";
import CartSvg from "../../../assets/img/icon/icon_cart.svg";
import HeaderSvg from "../../../assets/img/icon/icon_heart.svg";
import ArrowDownSvg from "../../../assets/img/icon/icon_arrow_down.svg";
import NoticeDeliverySvg from "../../../assets/img/icon/delivery.svg";
import RefundSvg from "../../../assets/img/icon/refund.svg";

// componet
import BasicBtn from "../../../component/button/BasicBtn";
import SelectBox from "../../../component/button/SelectBox";

// 임시 이미지
import Slider01 from "../../../assets/img/picture/product_01.jpg";
import Slider02 from "../../../assets/img/picture/product_02.jpg";
import Slider03 from "../../../assets/img/picture/product_03.jpg";
import Slider04 from "../../../assets/img/picture/product_04.jpg";
import Slider05 from "../../../assets/img/picture/product_05.jpg";
import Slider06 from "../../../assets/img/picture/product_06.jpg";
import A530Jpg from "../../../assets/img/picture/a530.jpg";
import DetailJpg from "../../../assets/img/picture/product_detail.jpg";

// testData
import { ProductData } from "../../../Data";

export default function ProductDetail() {
    // 클릭된 제품 데이터 받아오기
    let { id } = useParams();
    let selectItem = ProductData.find(function (item) {
        return item.id == id;
    });

    //페이지 이동
    const navigate = useNavigate();
    const payPage = () => {
        navigate(`/pay`);
    };
    const productpage = (id) => {
        navigate(`/product/detail/` + id);
    };
    const cartPage = (inStock) => {
        if (inStock == true) {
            navigate(`/cart`);
        }
        return null;
    };
    const wishPage = () => {
        navigate(`/wish`);
    };

    // Swiper
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    // 슬라이더 리스트
    const sliderList = [Slider01, Slider02, Slider03, Slider04, Slider05, Slider06];

    // 상품 선택 옵션
    const [optionBoxShow, setOptionBoxShow] = useState(false);
    const [optionSelect, setOptionSelect] = useState("옵션을 선택해주세요");
    const optionList = ["type A530 + smartStation™", "type A530"];

    // 상품 판매/품절 구분
    const [inStock, setInStock] = useState(true);

    const [openDetailBox, setOpenDetailBox] = useState(false);

    // 관련제품 리스트 data
    const relatedList = [
        {
            id: 0,
            content: "type A530",
            img: A530Jpg,
        },
        {
            id: 1,
            content: "type A530",
            img: A530Jpg,
        },
        {
            id: 2,
            content: "type A530",
            img: A530Jpg,
        },
    ];

    return (
        <Warp>
            <TopWrap>
                <SliderWrap>
                    {/* 섬네일 메인 슬라이드 */}
                    <Swiper
                        spaceBetween={10}
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        className="Thumbs_Slider"
                    >
                        {sliderList.map((value, index) => {
                            return (
                                <SwiperSlide key={"banner" + index}>
                                    <SlideImgBox>
                                        <SlideImgBg src={value} alt="슬라이드 배경" />
                                    </SlideImgBox>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>

                    {/* 서브 슬라이드 */}
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={10}
                        slidesPerView={6}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="Sub_Slider"
                        breakpoints={{
                            0: {
                                slidesPerView: 4.4,
                            },
                            901: {
                                slidesPerView: 6,
                            },
                        }}
                    >
                        {sliderList.map((value, index) => {
                            return (
                                <SwiperSlide key={"sub_banner" + index}>
                                    <SlideSmallImgBox>
                                        <SlideImgBg src={value} alt="슬라이드 배경" />
                                    </SlideSmallImgBox>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </SliderWrap>

                {/* --------- 1. 제품 정보 ----------- */}
                <ProductWrap>
                    <Name>{selectItem.itemName}</Name>

                    {/* 가격 */}
                    <PriceWrap>
                        <OriginPrice>{selectItem.orginPrice}</OriginPrice>
                        <DisCount>{selectItem.percent}%</DisCount>
                        <Price>{selectItem.price}원</Price>
                        <SmallText>( VAT포함 )</SmallText>
                    </PriceWrap>

                    {/* 사전주문 혜택 */}
                    <EarlyBirdBox>
                        <EarlyTitle>사전주문 혜택</EarlyTitle>
                        <BenefitListWrap>
                            <BenefitList>
                                <OrangeText>혜택 1</OrangeText>
                                <BenefitTextWrap>
                                    <OriginPrice>{selectItem.orginPrice}</OriginPrice>
                                    <DisCount>{selectItem.percent}%</DisCount>
                                    <Price>{selectItem.price}</Price>
                                    <Mobile>
                                        <VATText>( VAT포함 )</VATText>
                                    </Mobile>
                                </BenefitTextWrap>
                            </BenefitList>
                            <BenefitList>
                                <OrangeText>혜택 2</OrangeText>
                                <BenefitTextWrap>
                                    <BenefitText>보증기간 1년 연장 (보증기간 총 2년)</BenefitText>
                                </BenefitTextWrap>
                            </BenefitList>
                        </BenefitListWrap>
                    </EarlyBirdBox>

                    {/* 주의 */}
                    <CautionBox>
                        <CautionTitle>
                            주의사항
                            <Plus />
                        </CautionTitle>
                        <CautionListWrap>
                            <CautionList>- 정식 계약전 예약을 취소할 경우, 선결제금 전액을 환불받을 수 있습니다.</CautionList>
                            <CautionList>- 제품 옵션은 정식 계약시 변경 가능합니다.</CautionList>
                            <CautionList>- 선결제금은 추후 대금 결제 시 자동으로 결제 대금으로 사용됩니다.</CautionList>
                        </CautionListWrap>
                    </CautionBox>

                    <OptionBox>
                        <OptionTitle>
                            <OptionImg src={OptionSvg} alt="옵션 아이콘" /> option
                        </OptionTitle>
                        <OptionBigWrap>
                            <SelectBox
                                optionBoxShow={optionBoxShow}
                                setOptionBoxShow={setOptionBoxShow}
                                optionSelect={optionSelect}
                                setOptionSelect={setOptionSelect}
                                optionList={optionList}
                            />
                        </OptionBigWrap>
                    </OptionBox>

                    <DeliveryBox BorderColor={setInStock ? true : null}>
                        <DeliveryTitle>
                            <DeliveryImg src={DeliverySvg} alt="배송 아이콘" /> 배송
                        </DeliveryTitle>
                        <DeliveryListWrap>
                            <DeliveryList>
                                <DeliveryText>배송비</DeliveryText>
                                <DeliveryText>무료</DeliveryText>
                            </DeliveryList>
                            <DeliveryList>
                                <DeliveryText>도서, 산간지역 추가요금</DeliveryText>
                                <DeliveryText>3,000 원</DeliveryText>
                            </DeliveryList>
                        </DeliveryListWrap>
                        {
                            // 옵션 클릭시 재고가 있으면 나오는 부분
                            inStock && optionSelect !== "옵션을 선택해주세요" ? (
                                <ItemCountWrap>
                                    <CountTitle>
                                        <CountImg src={BagSvg} alt="수량 아이콘" /> 수량
                                    </CountTitle>
                                    <CountBtnWrap>
                                        <MinusBtn />
                                        <CountNum type="text" placeholder="1" />
                                        <PlusBtn />
                                    </CountBtnWrap>
                                </ItemCountWrap>
                            ) : null
                        }
                    </DeliveryBox>

                    <TotalBox>
                        {
                            // 제품 재고없을 시
                            !inStock && optionSelect !== "옵션을 선택해주세요" ? (
                                <SoldOutWrap>
                                    <SoldOutTitle>이 상품은 현재 구매하실 수 없는 상품입니다.</SoldOutTitle>
                                    <SoldOutDesc>(재입고 시 구매 가능)</SoldOutDesc>
                                </SoldOutWrap>
                            ) : (
                                // 제품 재고 있을 시 & 기본
                                <BuyNowWrap>
                                    <TotalText>Total</TotalText>
                                    <TotalPrice>0</TotalPrice>
                                    <Won>원</Won>
                                </BuyNowWrap>
                            )
                        }
                    </TotalBox>

                    <BtnAllWrap>
                        {
                            // 제품 재고없을 시 버튼 비활성화
                            // !inStock && optionListShow ?
                            !inStock ? (
                                <BigBtnWrap>
                                    <BasicBtn text="Reserve" disabled={true} />
                                </BigBtnWrap>
                            ) : (
                                // 제품 재고 있고, 비로그인시
                                // 제품 재고있고, 로그인시
                                <BigBtnWrap>
                                    <BasicBtn
                                        text="Reserve"
                                        bgWhite={true}
                                        onClick={() => {
                                            payPage();
                                        }}
                                    />
                                </BigBtnWrap>
                            )
                        }
                        <BtnWrap
                            inactive={inStock == false}
                            onClick={() => {
                                cartPage(inStock);
                            }}
                        >
                            <CartImg src={CartSvg} alt="장바구니 아이콘" />
                        </BtnWrap>
                        <BtnWrap
                            onClick={() => {
                                wishPage();
                            }}
                        >
                            <HeaderImg src={HeaderSvg} alt="위시리스트 아이콘" />
                        </BtnWrap>
                    </BtnAllWrap>
                </ProductWrap>
            </TopWrap>
            <MidWrap>
                <DetailWrap>
                    <ProductInfoWrap>
                        <InfoImgWrap heightActive={openDetailBox ? true : null}>
                            <InfoImg src={DetailJpg} alt="상세페이지" />
                        </InfoImgWrap>
                        <ReadMoreBtn
                            btnActive={openDetailBox == false}
                            onClick={() => {
                                setOpenDetailBox(!openDetailBox);
                            }}
                        >
                            {openDetailBox ? "close" : "open"}
                            <ArrowBottomIcon src={ArrowDownSvg} alt="더보기 아이콘" active={openDetailBox ? true : null} />
                        </ReadMoreBtn>
                    </ProductInfoWrap>
                    {/* 2. 배송정보 */}
                    <DeliveryWrap>
                        <NoticeTitle>
                            <NoticeIcon src={NoticeDeliverySvg} alt="택배 아이콘" />
                            <NoticeText>배송정보</NoticeText>
                        </NoticeTitle>
                        <NoticeListWrap>
                            <NoticeList>
                                Delivery 브랜드 업체발송은 상품설명에 별도로 기입된 브랜드 알림 배송공지 기준으로 출고되고 브랜드마다 개별 배송비가 부여됩니다.
                            </NoticeList>
                            <NoticeList>DSPECIAL ORDER, PT 등 예약주문은 상세설명의 출고일정을 확인하시기 바랍니다.</NoticeList>
                            <NoticeList>가구 및 일부 상품, 제주도를 포함한 도서산간 지역은 추가배송비 입금요청이 있을 수 있습니다.</NoticeList>
                        </NoticeListWrap>
                    </DeliveryWrap>
                    {/* 3. 교환정보 */}
                    <RefundWrap>
                        <NoticeTitle>
                            <NoticeIcon src={RefundSvg} alt="교환 아이콘" />
                            <NoticeText>교환정보</NoticeText>
                        </NoticeTitle>
                        <NoticeListWrap>
                            <NoticeList>
                                Delivery 브랜드 업체발송은 상품설명에 별도로 기입된 브랜드 알림 배송공지 기준으로 출고되고 브랜드마다 개별 배송비가 부여됩니다.
                            </NoticeList>
                            <NoticeList>DSPECIAL ORDER, PT 등 예약주문은 상세설명의 출고일정을 확인하시기 바랍니다.</NoticeList>
                            <NoticeList>구두, 액세서리, 침구, 액자, 가구 등 상품설명의 제작기간을 숙지해주시기 바랍니다.</NoticeList>
                            <NoticeList>가구 및 일부 상품, 제주도를 포함한 도서산간 지역은 추가배송비 입금요청이 있을 수 있습니다.</NoticeList>
                            <NoticeList>가구 및 일부 상품, 제주도를 포함한 도서산간 지역은 추가배송비 입금요청이 있을 수 있습니다.</NoticeList>
                            <NoticeList>가구 및 일부 상품, 제주도를 포함한 도서산간 지역은 추가배송비 입금요청이 있을 수 있습니다.</NoticeList>
                            <NoticeList>가구 및 일부 상품, 제주도를 포함한 도서산간 지역은 추가배송비 입금요청이 있을 수 있습니다.</NoticeList>
                            <NoticeList>가구 및 일부 상품, 제주도를 포함한 도서산간 지역은 추가배송비 입금요청이 있을 수 있습니다.</NoticeList>
                        </NoticeListWrap>
                    </RefundWrap>
                    {/* 4. 관련상품 */}
                    <BottomWrap>
                        <BigTitle>Related products</BigTitle>
                        <RelatedWrap>
                            {relatedList.map((item, index) => {
                                return (
                                    <RelatedList key={"relatedList" + index}>
                                        <RelatedImgWrap
                                            onClick={() => {
                                                productpage(item.id);
                                            }}
                                        >
                                            <RelatedImg src={item.img} alt={item.content} />
                                        </RelatedImgWrap>
                                        <RelatedText
                                            onClick={() => {
                                                productpage(item.id);
                                            }}
                                        >
                                            {item.content}
                                        </RelatedText>
                                    </RelatedList>
                                );
                            })}
                        </RelatedWrap>
                    </BottomWrap>
                </DetailWrap>
            </MidWrap>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    padding-top: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));

        padding-top: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        padding-top: ${M(30)};
    }
`;
const TopWrap = styled.section`
    display: flex;

    margin-bottom: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: block;

        margin-bottom: ${M(100)};
    }
`;

const SliderWrap = styled.div`
    position: relative;
    width: calc(100vw * (510 / 1920));
    height: calc(100vw * (615 / 1920));

    margin-right: calc(100vw * (40 / 1920));

    //swiper custom
    /* thumbs slider 메인 슬라이더  */
    & .Thumbs_Slider {
        width: 100%;
        height: calc(100vw * (510 / 1920));

        margin-bottom: calc(100vw * (10 / 1920));

        border: 1px solid #dddddd;
        background: #fafafa;
        border-radius: 4px;

        overflow: hidden;
    }

    & .Thumbs_Slider .swiper-wrapper {
        height: 100%;
    }

    //button custom
    & .Thumbs_Slider .swiper-button-prev,
    & .Thumbs_Slider .swiper-button-next {
        display: none;

        width: calc(100vw * (48 / 1920));
        height: calc(100vw * (48 / 1920));

        transition: all 0.2s;

        z-index: 2;
        background: url(${SwiperBtn}) no-repeat center center / contain;
    }

    & .Thumbs_Slider:hover .swiper-button-prev,
    & .Thumbs_Slider:hover .swiper-button-next {
        display: block;
    }

    & .Thumbs_Slider .swiper-button-prev:after,
    & .Thumbs_Slider .swiper-button-next:after {
        display: none;
    }

    & .Thumbs_Slider .swiper-button-prev {
        left: 0;
    }

    & .Thumbs_Slider .swiper-button-next {
        right: 0;
        transform: rotate(180deg);
    }

    /* Sub_Slider 서브 슬라이더  */
    & .Sub_Slider {
        width: 100%;
        height: calc(100vw * (75 / 1920));
    }

    & .Sub_Slider .swiper-slide {
        border-radius: 2px;
        border: 1px solid #eee;

        cursor: pointer;

        overflow: hidden;
    }

    & .Sub_Slider .swiper-slide-thumb-active {
        border-color: var(--main-color);
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
        height: calc(100vw * (615 / 1300));

        margin-right: calc(100vw * (40 / 1300));

        //swiper custom
        /* thumbs slider 메인 슬라이더  */
        & .Thumbs_Slider {
            height: calc(100vw * (510 / 1300));

            margin-bottom: calc(100vw * (10 / 1300));
        }

        //button custom
        & .Thumbs_Slider .swiper-button-prev,
        & .Thumbs_Slider .swiper-button-next {
            width: calc(100vw * (48 / 1300));
            height: calc(100vw * (48 / 1300));
        }

        /* Sub_Slider 서브 슬라이더  */
        & .Sub_Slider {
            height: calc(100vw * (75 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        height: ${M(476)};

        margin-right: 0;
        margin-bottom: ${M(20)};

        //swiper custom
        /* thumbs slider 메인 슬라이더  */
        & .Thumbs_Slider {
            height: ${M(378)};

            margin-bottom: ${M(20)};
        }

        //button custom
        & .Thumbs_Slider .swiper-button-prev,
        & .Thumbs_Slider .swiper-button-next {
            display: block;

            width: ${M(36)};
            height: ${M(36)};
        }

        & .Thumbs_Slider:hover .swiper-button-prev,
        & .Thumbs_Slider:hover .swiper-button-next {
            display: block;
        }
        /* 
    & .Thumbs_Slider .swiper-button-prev:after,
    & .Thumbs_Slider .swiper-button-next:after {
        display: none;
    } */

        /* Sub_Slider 서브 슬라이더  */
        & .Sub_Slider {
            height: ${M(78)};
        }
    }
`;
const SlideImgBox = styled.div`
    width: 100%;
`;
const SlideSmallImgBox = styled.div`
    width: 100%;
`;

const SlideImgBg = styled.img`
    display: block;
    width: 100%;
    height: auto;

    object-fit: cover;
`;

const ProductWrap = styled.div`
    position: relative;
    width: calc(100vw * (510 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;

const Name = styled.h2`
    font-family: "Pop-L";
    font-size: calc(100vw * (50 / 1920));

    margin-bottom: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(35)};

        margin-bottom: ${M(10)};
    }
`;

const PriceWrap = styled.div`
    display: flex;
    /* align-items: flex-end; */
    align-items: baseline;
    flex-wrap: wrap;

    margin-bottom: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(10)};
    }
`;

const OriginPrice = styled.s`
    font-family: "Noto-R";
    font-size: calc(100vw * (18 / 1920));
    color: #ccc;

    margin-right: calc(100vw * (10 / 1920));
    word-break: break-all;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (18 / 1300));

        margin-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        margin-right: ${M(5)};
    }
`;

const DisCount = styled.strong`
    font-family: "Pop-B";
    font-size: calc(100vw * (25 / 1920));
    color: var(--main-color);

    margin-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));

        margin-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-right: ${M(5)};
    }
`;

const Price = styled.p`
    font-family: "Noto-B";
    font-size: calc(100vw * (25 / 1920));
    margin-right: calc(100vw * (5 / 1920));

    & span {
        font-size: calc(100vw * (20 / 1920));
        font-family: "Noto-R";
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
        margin-right: calc(100vw * (5 / 1300));

        & span {
            font-size: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-right: ${M(5)};
        & span {
            font-size: ${M(14)};
        }
    }
`;
const VATText = styled.p`
    color: #aaaaaa;
    font-size: calc(100vw * (13 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const SmallText = styled.p`
    font-size: calc(100vw * (13 / 1920));
    color: #aaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const EarlyBirdBox = styled.div`
    padding: calc(100vw * (15 / 1920));
    background: #fafafa;

    border: 1px solid #ddd;
    border-radius: 6px;

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (15 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(15)};
        margin-bottom: ${M(20)};
    }
`;

const EarlyTitle = styled.p`
    font-family: "Noto-B";
    font-size: calc(100vw * (15 / 1920));

    margin-bottom: calc(100vw * (12 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (12 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-bottom: ${M(11)};
    }
`;

const BenefitListWrap = styled.ul``;

const BenefitList = styled.li`
    display: flex;
    align-items: center;

    &:not(:first-child) {
        margin-top: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(5)};
        }
    }
`;

const OrangeText = styled.p`
    font-size: calc(100vw * (13 / 1920));
    color: var(--main-color);
    margin-right: calc(100vw * (20 / 1920));

    border: 1px solid var(--main-color);
    border-radius: 50px;

    padding: calc(100vw * (5 / 1920)) calc(100vw * (11 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
        margin-right: calc(100vw * (20 / 1300));

        padding: calc(100vw * (5 / 1300)) calc(100vw * (11 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        margin-right: ${M(10)};
        padding: ${M(6)} ${M(12)};
    }
`;

const BenefitTextWrap = styled.div`
    display: flex;
    align-items: center;

    & s {
        margin-right: calc(100vw * (6 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & s {
            margin-right: calc(100vw * (6 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & s {
            margin-right: ${M(5)};
        }
    }
`;

const BenefitText = styled.p`
    font-family: "Noto-R";
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const CautionBox = styled.details`
    margin-bottom: calc(100vw * (20 / 1920));

    &[open] summary > p:before {
        height: 0;
    }

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(20)};
    }
`;

const CautionTitle = styled.summary`
    display: inline-flex;
    align-items: center;
    white-space: nowrap;

    font-family: "Noto-B";
    font-size: calc(100vw * (15 / 1920));
    color: var(--main-color);

    margin-bottom: calc(100vw * (10 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
        margin-bottom: ${M(5)};
    }
`;
const Plus = styled.p`
    position: relative;
    width: calc(100vw * (16 / 1920));
    height: calc(100vw * (16 / 1920));

    margin-left: calc(100vw * (5 / 1920));

    border: 2px solid var(--main-color);
    border-radius: 50%;

    &:after,
    &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";

        background: var(--main-color);

        transform: translate(-50%, -50%);
    }

    &:after {
        width: calc(100vw * (8 / 1920));
        height: 2px;
    }
    &:before {
        width: 2px;
        height: calc(100vw * (8 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (16 / 1300));
        height: calc(100vw * (16 / 1300));

        margin-left: calc(100vw * (5 / 1300));

        &:after {
            width: calc(100vw * (8 / 1300));
        }
        &:before {
            height: calc(100vw * (8 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};

        width: ${M(15)};
        height: ${M(15)};

        margin-left: ${M(6)};

        &:after {
            width: ${M(7)};
        }
        &:before {
            height: ${M(7)};
        }
    }
`;

const CautionListWrap = styled.ul``;

const CautionList = styled.li`
    font-size: calc(100vw * (15 / 1920));

    color: #aaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(12)};
    }
`;

const OptionBox = styled.div`
    padding-bottom: calc(100vw * (20 / 1920));

    border-bottom: 1px solid #eee;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
    }
`;

const OptionTitle = styled.p`
    display: flex;
    align-items: center;

    font-size: calc(100vw * (15 / 1920));
    color: #8c8c8c;

    margin-bottom: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
        margin-bottom: ${M(10)};
    }
`;

const OptionImg = styled.img`
    width: calc(100vw * (24 / 1920));
    height: calc(100vw * (24 / 1920));
    margin-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (24 / 1300));
        height: calc(100vw * (24 / 1300));
        margin-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(24)};
        height: ${M(24)};
        margin-right: ${M(10)};
    }
`;

const OptionBigWrap = styled.div`
    width: 100%;
`;

const DeliveryBox = styled.div`
    padding: calc(100vw * (20 / 1920)) 0;

    border-bottom: 1px solid;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;
    }

    /*  왜 넣은거지?
    ${({ BorderColor }) => {
        return (
            BorderColor &&
            `
            border-color:#EEE;
        `
        );
    }} */
`;

const DeliveryTitle = styled(OptionTitle)`
    margin-bottom: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(10)};
    }
`;

const DeliveryImg = styled.img`
    width: calc(100vw * (26 / 1920));
    height: calc(100vw * (17 / 1920));

    margin-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (26 / 1300));
        height: calc(100vw * (17 / 1300));

        margin-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(24)};
        height: ${M(16)};

        margin-right: ${M(10)};
    }
`;

const DeliveryListWrap = styled.ul``;

const DeliveryList = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:first-child) {
        margin-top: calc(100vw * (5 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (5 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(6)};
        }
    }
`;

const DeliveryText = styled.p`
    font-size: calc(100vw * (15 / 1920));
    color: #aaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const ItemCountWrap = styled.div`
    display: flex;
    align-items: center;

    margin-top: calc(100vw * (20 / 1920));
    padding-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #eee;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
        padding-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
        padding-top: ${M(20)};
    }
`;

const CountTitle = styled(OptionTitle)`
    margin-bottom: 0;
`;

const CountImg = styled.img`
    width: calc(100vw * (15 / 1920));
    height: calc(100vw * (20 / 1920));

    margin-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (15 / 1300));
        height: calc(100vw * (20 / 1300));

        margin-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(14)};
        height: ${M(19)};

        margin-right: ${M(10)};
    }
`;

const CountBtnWrap = styled.div`
    display: flex;
    align-items: center;

    margin-left: auto;
`;

const MinusBtn = styled.p`
    position: relative;
    width: calc(100vw * (21 / 1920));
    height: calc(100vw * (21 / 1920));

    border: 1px solid #ddd;

    cursor: pointer;

    &:after {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        width: calc(100vw * (9 / 1920));
        height: 1px;

        background: #222;

        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (21 / 1300));
        height: calc(100vw * (21 / 1300));

        &:after {
            width: calc(100vw * (9 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(21)};
        height: ${M(21)};

        &:after {
            width: ${M(8)};
        }
    }
`;

const CountNum = styled.input`
    width: calc(100vw * (50 / 1920));
    font-size: calc(100vw * (15 / 1920));
    text-align: center;

    &::placeholder {
        color: #222;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (50 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(40)};
        font-size: ${M(14)};
    }
`;

const PlusBtn = styled(MinusBtn)`
    &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        width: 1px;
        height: calc(100vw * (9 / 1920));

        background: #222;

        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 1300px) {
        &:before {
            height: calc(100vw * (9 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:before {
            height: ${M(8)};
        }
    }
`;

const TotalBox = styled.div``;

// 판매가능
const BuyNowWrap = styled.div`
    display: flex;
    align-items: baseline;

    padding: calc(100vw * (30 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (30 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(30)} 0;
    }
`;

const TotalText = styled.p`
    font-family: "Pop-B";
    font-size: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const TotalPrice = styled.p`
    flex-shrink: 0;

    font-family: "Pop-B";
    font-size: calc(100vw * (20 / 1920));

    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-left: auto;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
// 판매불가
const SoldOutWrap = styled.div`
    text-align: center;
    padding: calc(100vw * (54 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (54 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0 ${M(27)};
    }
`;

const SoldOutTitle = styled.p`
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
    }
`;

const SoldOutDesc = styled(SoldOutTitle)`
    color: #aaa;
`;

const Won = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (20 / 1920));
    font-size: calc(100vw * (20 / 1920));
    font-family: "Noto-M";

    margin-left: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        font-size: calc(100vw * (20 / 1300));

        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        font-size: ${M(20)};

        margin-left: ${M(10)};
    }
`;
const BtnAllWrap = styled.div`
    display: flex;
    align-items: center;
`;

const BigBtnWrap = styled.div`
    width: calc(100vw * (382 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (382 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(260)};
    }
`;

const BtnWrap = styled.p`
    display: flex;

    width: calc(100vw * (50 / 1920));
    height: calc(100vw * (50 / 1920));

    cursor: pointer;

    border: 1px solid #ddd;
    border-radius: 5px;

    margin-left: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (50 / 1300));
        height: calc(100vw * (50 / 1300));

        margin-left: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(45)};
        height: ${M(45)};
        margin-left: ${M(14)};
    }

    ${({ inactive }) => {
        return (
            inactive &&
            `
            cursor: unset; 

            & img{
                opacity: 0.5;
            }
        `
        );
    }}
`;

const CartImg = styled.img`
    width: calc(100vw * (28 / 1920));
    height: calc(100vw * (28 / 1920));

    margin: auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (28 / 1300));
        height: calc(100vw * (28 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};
    }
`;

const HeaderImg = styled.img`
    width: calc(100vw * (28 / 1920));
    height: calc(100vw * (23 / 1920));

    margin: auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (28 / 1300));
        height: calc(100vw * (23 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};
    }
`;

const MidWrap = styled.div`
    position: relative;
    width: 100%;
`;

const BottomWrap = styled.article``;

const BigTitle = styled.h3`
    font-family: "Pop-M";
    font-size: calc(100vw * (30 / 1920));
    text-align: center;

    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (30 / 1300));

        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(16)};
        margin-bottom: ${M(30)};
    }
`;

const RelatedWrap = styled.ul`
    display: flex;
    align-items: center;
`;

const RelatedList = styled.li`
    width: calc(100vw * (324 / 1920));

    &:not(:first-child) {
        margin-left: calc(100vw * (44 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (324 / 1300));

        &:not(:first-child) {
            margin-left: calc(100vw * (44 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(122)};

        &:not(:first-child) {
            margin-left: ${M(6)};
        }
    }
`;

const RelatedImgWrap = styled.div`
    width: 100%;
    height: calc(100vw * (260 / 1920));

    border: 1px solid #ddd;
    border-radius: 5px;
    overflow: hidden;

    margin-bottom: calc(100vw * (20 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (260 / 1300));

        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(98)};
        margin-bottom: ${M(10)};
    }
`;

const RelatedImg = styled.img`
    width: 100%;
    height: auto;

    object-fit: cover;
`;

const RelatedText = styled.p`
    font-family: "Pop-B";
    font-size: calc(100vw * (20 / 1920));
    text-align: center;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;

// Detail Tab 부분
const DetailWrap = styled.section`
    padding-bottom: calc(100vw * (200 / 1920));

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(100)};
    }
`;

// 1. 상품정보
const ProductInfoWrap = styled.article`
    position: relative;
    margin-bottom: calc(100vw * (190 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (190 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(42)};
    }
`;
const InfoImgWrap = styled.div`
    position: relative;
    width: 100%;
    height: calc(100vw * (1190 / 1920));
    overflow: hidden;

    &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: "";

        width: 100%;
        height: calc(100vw * (760 / 1920));
        background-image: linear-gradient(to top, #fafafa, rgba(255, 255, 255, 0));
    }

    ${({ heightActive }) => {
        return (
            heightActive &&
            `
                height: auto;
            `
        );
    }}

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (1190 / 1300));

        &:after {
            height: calc(100vw * (760 / 1300));
        }

        ${({ heightActive }) => {
            return (
                heightActive &&
                `
                    height: auto;
                `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        height: ${M(635)};

        &:after {
            height: ${M(500)};
        }

        ${({ heightActive }) => {
            return (
                heightActive &&
                `
                    height: auto;
                `
            );
        }}
    }
`;

const InfoImg = styled.img`
    width: 100%;
    height: auto;
`;
const ReadMoreBtn = styled.p`
    position: absolute;
    bottom: 0;
    left: 50%;

    width: calc(100vw * (235 / 1920));

    font-family: "Pop-M";
    font-size: calc(100vw * (30 / 1920));
    text-align: center;

    padding: calc(100vw * (19 / 1920)) 0;

    background: #fff;
    border: 1px solid #ddd;
    border-radius: 50px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    cursor: pointer;

    transform: translate(-50%, 50%);

    z-index: 2;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (235 / 1300));

        font-size: calc(100vw * (30 / 1300));

        padding: calc(100vw * (19 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        width: ${M(180)};
        font-size: ${M(16)};
        padding: ${M(11)} 0;
    }
`;

const ArrowBottomIcon = styled.img`
    width: calc(100vw * (15 / 1920));
    height: calc(100vw * (8 / 1920));

    margin-left: calc(100vw * (10 / 1920));

    filter: invert(58%) sepia(2%) saturate(2%) hue-rotate(322deg) brightness(95%) contrast(88%);

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (15 / 1300));
        height: calc(100vw * (8 / 1300));

        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(11)};
        height: ${M(6)};
        margin-left: ${M(9)};
    }

    ${({ active }) => {
        return (
            active &&
            `
            transform: rotate(180deg);
        `
        );
    }}
`;

/* 2. 배송정보 // 3. 교환정보 */

const DeliveryWrap = styled.article`
    margin-bottom: calc(100vw * (30 / 1920));
    padding-bottom: calc(100vw * (30 / 1920));
    border-bottom: 1px solid #eeeeee;

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (30 / 1300));
        padding-bottom: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(30)};
        padding-bottom: ${M(30)};
    }
`;
const RefundWrap = styled.article`
    margin-bottom: calc(100vw * (283 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (283 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(80)};
    }
`;

const NoticeTitle = styled.div`
    display: inline-flex;
    align-items: center;

    margin-bottom: calc(100vw * (20 / 1920));
    border: 1px solid var(--main-color);
    border-radius: 50px;

    padding: calc(100vw * (5 / 1920)) calc(100vw * (16 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));

        padding: calc(100vw * (5 / 1300)) calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(20)};
        padding: ${M(7)} ${M(14)};
    }
`;
const NoticeIcon = styled.img`
    width: calc(100vw * (29 / 1920));
    height: calc(100vw * (29 / 1920));

    margin-right: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (29 / 1300));
        height: calc(100vw * (29 / 1300));

        margin-right: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};

        margin-right: ${M(5)};
    }
`;
const NoticeText = styled.h4`
    font-size: calc(100vw * (16 / 1920));
    color: var(--main-color);

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const NoticeListWrap = styled.ul``;

const NoticeList = styled.li`
    position: relative;
    font-size: calc(100vw * (14 / 1920));
    padding-left: calc(100vw * (10 / 1920));

    &:not(:first-child) {
        margin-top: calc(100vw * (10 / 1920));
    }

    &:after {
        position: absolute;
        top: calc(100vw * (10 / 1920));
        left: 0;
        content: "";

        width: calc(100vw * (5 / 1920));
        height: 1px;

        background: var(--main-color);
        transform: translateY(-50%);
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        padding-left: calc(100vw * (10 / 1300));

        &:not(:first-child) {
            margin-top: calc(100vw * (10 / 1300));
        }

        &:after {
            top: calc(100vw * (10 / 1300));
            width: calc(100vw * (5 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        padding-left: ${M(10)};

        &:not(:first-child) {
            margin-top: ${M(10)};
        }

        &:after {
            top: ${M(10)};
            width: ${M(5)};
        }
    }
`;
